import React from 'react';
import Hero from '../components/Hero';
import Marquee from '../components/Marquee';
import About from '../components/About';
import Services from '../components/Services';
import Projects from '../components/Projects';
import Statistics from '../components/Statistics';
import Contact from '../components/Contact';

export default function HomePage() {
  return (
    <main data-testid="home-page">
      <Hero />
      <Marquee />
      <About />
      <Services />
      <Projects />
      <Statistics />
      <Contact />
    </main>
  );
}
